module.exports = __webpack_public_path__ + "static/media/ic_thumb_up_24px.a0535d92.svg";